import './style.scss'
import { Button, ColorPicker, message, Modal, Select } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Aajht from '@/assets/fonts/Aa剑豪体.png'
import Aahdh from '@/assets/fonts/Aa厚底黑.png'
// import BagnardSans from '@/assets/fonts/Bagnard.png'
import CangJiGaoDeGuoMiaoHei from '@/assets/fonts/CangJiGaoDeGuoMiaoHei-CJgaodeguomh-2仓迹高德国妙黑.png'
import JingNanBoBoHei from '@/assets/fonts/JingNanBoBoHei-Bold-2.png'
// import LibreBaskerville from '@/assets/fonts/Libre Baskerville.png'
// import MilkyCoffee from '@/assets/fonts/MilkyCoffee.png'
import SiYuanHeiTiHeavy from '@/assets/fonts/SiYuanHeiTi-Heavy.png'
import SiYuanHeiTiLight from '@/assets/fonts/SiYuanHeiTi-Light.png'
import SiYuanHeiTiRegular from '@/assets/fonts/SiYuanHeiTi-Regular.png'
import ZiZhiQuXiMaiTi from '@/assets/fonts/ZiZhiQuXiMaiTi-2.png'
import Sjlltjc from '@/assets/fonts/三极力量体简-粗.png'
import Sjpmt from '@/assets/fonts/三极泼墨体.png'
import Sjsxjt from '@/assets/fonts/三极素纤简体.png'
import Sjhkjtc from '@/assets/fonts/三极行楷简体-粗.png'
import Yffyt from '@/assets/fonts/云峰飞云体.png'
import Yshst from '@/assets/fonts/优设好身体.png'
import Ysbty from '@/assets/fonts/优设标题-圆.png'
import Ysbtj from '@/assets/fonts/优设标题-黑.png'
import Yssyftjkt from '@/assets/fonts/优设鲨鱼菲特健康体.png'
import Lhktss from '@/assets/fonts/刘欢卡通手书.png'
import Qtxtt from '@/assets/fonts/千图小兔体.png'
import Nmt from '@/assets/fonts/南安体.png'
import Ztqxyght from '@/assets/fonts/字体圈欣意冠黑体.png'
import Ztqxyjxs from '@/assets/fonts/字体圈欣意吉祥宋.png'
import Zhbtt from '@/assets/fonts/字魂扁桃体.png'
import Xknnt from '@/assets/fonts/小可奶酪体.png'
import Pmzdbt from '@/assets/fonts/庞门正道标题.png'
import Dyh from '@/assets/fonts/得意黑.png'
import Kksjb from '@/assets/fonts/快看世界体.png'
import Syst from '@/assets/fonts/思源宋体.png'
import Dymht from '@/assets/fonts/抖音美好体.png'
import Wdpljzx from '@/assets/fonts/文鼎PL简中楷.png'
import Dyzgt from '@/assets/fonts/斗鱼追光体.png'
import Fzssjt from '@/assets/fonts/方正书宋-简体.png'
import Jyhphy from '@/assets/fonts/极影毁片和圆.png'
import Ysxxk from '@/assets/fonts/演示夏行楷.png'
import Adfyh from '@/assets/fonts/爱点风雅黑.png'
import Zkwyt from '@/assets/fonts/站酷文艺体.png'
import Wzsf from '@/assets/fonts/问藏书房.png'
import Almmlt from '@/assets/fonts/阿里妈妈刀隶体.png'
import Almmfyt from '@/assets/fonts/阿里妈妈方圆体.png'
import Hlcsjt from '@/assets/fonts/鸿雷拙书简体.png'
import Dlskt from '@/assets/fonts/鼎猎宋刻体.png'
import { urlSource } from '@/libs/util'
import { presetPalettes } from '@ant-design/colors'
import { LoadingOutlined, StopOutlined } from '@ant-design/icons'

import type { ColorPickerProps } from 'antd'
const fontOptions = [
  {
    value: 'Douyin Sans',
    fontWidth: 0.9,
    className: 'Douyin_Sans',
    url: urlSource('hiflys/fonts/抖音美好体.otf'),
    previewImg: Dymht
  },
  {
    value: 'Kingnam Bobo',
    fontWidth: 0.9,
    url: urlSource('hiflys/fonts/荆南波波黑.otf'),
    previewImg: JingNanBoBoHei
  },
  {
    value: 'Source Han Sans SC Heavy',
    url: urlSource('hiflys/fonts/SiYuanHeiTi-Heavy.otf'),
    fontWidth: 1.1,
    previewImg: SiYuanHeiTiHeavy
  },
  {
    value: 'ZiZhiQuXiMaiTi',
    fontWidth: 0.9,
    url: urlSource('hiflys/fonts/ZiZhiQuXiMaiTi-2.ttf'),
    previewImg: ZiZhiQuXiMaiTi
  },
  {
    value: 'Alimama FangYuanTi VF',
    fontWidth: 0.9,
    url: urlSource('hiflys/fonts/阿里妈妈方圆体.ttf'),
    previewImg: Almmfyt
  },
  { value: 'YouSheBiaoTiHei', fontWidth: 0.9, url: urlSource('hiflys/fonts/优设标题黑.ttf'), previewImg: Ysbtj },
  { value: 'YouSheBiaoTiYuan', fontWidth: 0.9, url: urlSource('hiflys/fonts/优设标题圆.otf'), previewImg: Ysbty },
  { value: 'zihunbiantaoti', fontWidth: 0.8, url: urlSource('hiflys/fonts/字魂扁桃体.ttf'), previewImg: Zhbtt },
  { value: '云峰飞云体', fontWidth: 0.95, url: urlSource('hiflys/fonts/云峰飞云体2.ttf'), previewImg: Yffyt },
  { value: 'WenCang', url: urlSource('hiflys/fonts/问藏书房.ttf'), previewImg: Wzsf },
  { value: 'ZQKNLT', url: urlSource('hiflys/fonts/小可奶酪体.ttf'), previewImg: Xknnt },
  { value: 'QTxiaotu', fontWidth: 0.96, url: urlSource('hiflys/fonts/千图小兔体.ttf'), previewImg: Qtxtt },
  { value: 'AR PL KaitiM GB', fontWidth: 0.93, url: urlSource('hiflys/fonts/文鼎PL简中楷.ttf'), previewImg: Wdpljzx },
  { value: 'Slidexiaxing', fontWidth: 1.08, url: urlSource('hiflys/fonts/演示夏行楷.ttf'), previewImg: Ysxxk },
  {
    value: 'Alimama DaoLiTi',
    fontWidth: 0.95,
    className: 'Alimama_DaoLiTi',
    url: urlSource('hiflys/fonts/阿里妈妈刀隶体.ttf'),
    previewImg: Almmlt
  },
  { value: '極影毀片和圓', fontWidth: 0.95, url: urlSource('hiflys/fonts/极影毁片和圆.ttf'), previewImg: Jyhphy },
  { value: 'Smiley Sans Oblique', fontWidth: 0.8, url: urlSource('hiflys/fonts/得意黑.otf'), previewImg: Dyh },
  { value: 'Aidian FengYaHei', fontWidth: 0.95, url: urlSource('hiflys/fonts/爱点风雅黑.ttf'), previewImg: Adfyh },
  { value: 'dingliesongtypeface', fontWidth: 0.92, url: urlSource('hiflys/fonts/鼎猎宋刻体.ttf'), previewImg: Dlskt },
  { value: 'FZShuSong-Z01S', fontWidth: 0.95, url: urlSource('hiflys/fonts/方正书宋-简体.ttf'), previewImg: Fzssjt },

  {
    value: 'Source Han Sans SC',
    fontWidth: 0.95,
    url: urlSource('hiflys/fonts/SiYuanHeiTi-Regular.otf'),
    previewImg: SiYuanHeiTiRegular
  },
  {
    value: 'Source Han Sans SC Light',
    fontWidth: 0.95,
    url: urlSource('hiflys/fonts/SiYuanHeiTi-Light.otf'),
    previewImg: SiYuanHeiTiLight
  },
  {
    value: 'Source Han Serif CN Light',
    fontWidth: 0.93,
    url: urlSource('hiflys/fonts/思源宋体.otf'),
    previewImg: Syst
  },
  // { value: 'ÖÜÖZhouZiSong', fontWidth: 0.93, url: urlSource('hiflys/fonts/周字宋体.otf'), previewImg: Zzst },
  // {
  //   value: 'HYHuaXianZiShiny',
  //   fontWidth: 0.95,
  //   url: urlSource('hiflys/fonts/汉仪花仙子闪亮版-简.ttf'),
  //   previewImg: Hyhxzslbj
  // },
  // { value: 'HYXiaoYaoYou', fontWidth: 0.95, url: urlSource('hiflys/fonts/汉仪逍遥游-简.ttf'), previewImg: Hyxyyj },
  {
    value: 'Liu Huan KaTong ShouShu',
    fontWidth: 0.95,
    url: urlSource('hiflys/fonts/刘欢卡通手书.ttf'),
    previewImg: Lhktss
  },
  {
    value: '庞门正道标题体免费版',
    fontWidth: 0.95,
    url: urlSource('hiflys/fonts/庞门正道标题.ttf'),
    previewImg: Pmzdbt
  },
  { value: '三极泼墨体', fontWidth: 0.93, url: urlSource('hiflys/fonts/三极泼墨体.ttf'), previewImg: Sjpmt },
  {
    value: '三极力量体简-粗',
    fontWidth: 0.93,
    url: urlSource('hiflys/fonts/三极力量体简-粗.ttf'),
    previewImg: Sjlltjc
  },
  { value: 'SJxingkai-C', url: urlSource('hiflys/fonts/三极行楷简体-粗.ttf'), previewImg: Sjhkjtc },
  { value: 'SJsuqian', fontWidth: 0.93, url: urlSource('hiflys/fonts/三极素纤简体.ttf'), previewImg: Sjsxjt },
  { value: 'ziticqnananti', fontWidth: 0.95, url: urlSource('hiflys/fonts/南安体.ttf'), previewImg: Nmt },
  { value: 'YOUSHEhaoshenti', url: urlSource('hiflys/fonts/优设好身体.ttf'), previewImg: Yshst },
  {
    value: 'YouSheShaYuFeiTeJianKangTi',
    url: urlSource('hiflys/fonts/优设鲨鱼菲特健康体.ttf'),
    previewImg: Yssyftjkt
  },
  { value: 'zcoolwenyiti', fontWidth: 0.95, url: urlSource('hiflys/fonts/站酷文艺体.ttf'), previewImg: Zkwyt },
  { value: 'FontquanXinYiGuanHeiTi', url: urlSource('hiflys/fonts/字体圈欣意冠黑体.ttf'), previewImg: Ztqxyght },
  { value: 'Fontquan-XinYiJiXiangSong', url: urlSource('hiflys/fonts/字体圈欣意吉祥宋.ttf'), previewImg: Ztqxyjxs },
  { value: 'AaHouDiHei', fontWidth: 0.94, url: urlSource('hiflys/fonts/Aa厚底黑.ttf'), previewImg: Aahdh },
  { value: 'AaJianHaoTi', fontWidth: 0.93, url: urlSource('hiflys/fonts/Aa剑豪体.ttf'), previewImg: Aajht },

  {
    value: 'CJGaoDeGuo-MH',
    fontWidth: 0.7,
    url: urlSource('hiflys/fonts/仓迹高德国妙黑.otf'),
    previewImg: CangJiGaoDeGuoMiaoHei
  },
  // {
  //   value: 'KouzanBrushFontSousyo',
  //   fontWidth: 0.95,
  //   url: urlSource('hiflys/fonts/衡山毛笔草书.ttf'),
  //   previewImg: Hsmbcs
  // },
  { value: 'HongLeiZhuoShu', fontWidth: 0.75, url: urlSource('hiflys/fonts/鸿雷拙书简体.ttf'), previewImg: Hlcsjt },
  {
    value: 'DOUYU Font',
    fontWidth: 1.2,
    className: 'DOUYU_Font',
    url: urlSource('hiflys/fonts/斗鱼追光体.otf'),
    previewImg: Dyzgt
  },
  { value: '快看世界体', fontWidth: 1.0, url: urlSource('hiflys/fonts/快看世界体.ttf'), previewImg: Kksjb }
  // { value: 'Hey November', url: urlSource('hiflys/fonts/Hey-November-2.otf'), previewImg: HeyNovember },
  // { value: 'Bagnard Sans Regular', url: urlSource('hiflys/fonts/BagnardSans-2.otf'), previewImg: BagnardSans },
  // {
  //   value: 'Libre Baskerville',
  //   url: urlSource('hiflys/fonts/LibreBaskerville-Regular-2.ttf'),
  //   previewImg: LibreBaskerville
  // },
  // { value: 'Milky Coffee', url: urlSource('hiflys/fonts/MilkyCoffee-gx1yR-2.ttf'), previewImg: MilkyCoffee }
]

type Presets = Required<ColorPickerProps>['presets'][number]

function genPresets(presets = presetPalettes) {
  return Object.entries(presets).map<Presets>(([label, colors]) => ({ label, colors, key: label }))
}

const colors = [
  '#FF1744',
  '#D500F9',
  '#651FFF',
  '#3D5AFE',
  '#00B0FF',
  '#00E5FF',
  '#1DE9B6',
  '#00E676',
  '#C6FF00',
  '#FFEA00',
  '#FFC400',
  '#FF9100',
  '#000000',
  '#9E9E9E',
  '#C7C7CC',
  '#FFFFFF'
]

const fontSizeList = [24, 28, 32, 36, 42, 48, 56, 64, 72, 80, 86, 92, 100, 112, 120, 140]

const styleList = [
  {
    fontColor: '#FFFFFF',
    borderColor: '#000000'
  },
  {
    fontColor: '#000000',
    borderColor: '#FFFFFF'
  },
  {
    fontColor: '#FFDE00',
    borderColor: '#000000'
  },
  {
    fontColor: '#FFFFFF',
    borderColor: '#FE8A80'
  },
  {
    fontColor: '#B7DCF6',
    borderColor: '#000000'
  },
  {
    fontColor: '#FFD9E8',
    borderColor: '#FF619D'
  },
  {
    fontColor: '#C0F1F5',
    borderColor: '#469DF3'
  },
  {
    fontColor: '#C3CF47',
    borderColor: '#3C5C37'
  },
  {
    fontColor: '#90C2CD',
    borderColor: '#465773'
  },
  {
    fontColor: '#FFFFFF',
    borderColor: '#FF1837'
  },
  {
    fontColor: '#AB4A37',
    borderColor: '#FFFFFF'
  },
  {
    fontColor: '#F9F3C4',
    borderColor: '#4A4238'
  },
  {
    fontColor: '#FFD9C6',
    borderColor: '#A74F59'
  },
  {
    fontColor: '#FFFFFF',
    borderColor: '#008000'
  },
  {
    fontColor: '#FFFFFF',
    borderColor: '#FFA500'
  },
  {
    fontColor: '#FFFFFF',
    borderColor: '#651fff'
  },
  {
    fontColor: '#000000',
    borderColor: '#76FF03'
  }
]

const leftMaxWidth = 480
const leftMaxHeight = 480
const screenSize = 1920

interface IProps {
  open: boolean
  avatar: any
  caption: any
  onCancel: () => void
  updateCaption: (avatar: any) => void
}

const CaptionModal = forwardRef((props: IProps, ref) => {
  const { open, avatar, caption, onCancel, updateCaption } = props
  const { t: translate } = useTranslation(['create_video'])
  const presets = genPresets({ 预设颜色: colors })
  const [ratio, setRatio] = useState<any>()
  const [naturalSize, setNaturalSize] = useState<any>({})
  const [fontSize, setFontSize] = useState(72)
  const [fontColor, setFontColor] = useState('')
  const [fontBorderColor, setFontBorderColor] = useState('')
  const [fontStyleIndx, setFontStyleIndx] = useState<any>()
  const [selectedFont, setSelectedFont] = useState<string>('')
  const [fontLoading, setFontLoading] = useState(false)
  // 修改previewBox的初始化状态
  const [previewBox, setPreviewBox] = useState({
    x: 0,
    y: 0,
    width: 0,
    isDragging: false,
    isResizing: false,
    resizeDirection: null as 'left' | 'right' | null // 添加调整方向
  })
  const [isPreviewBoxActive, setIsPreviewBoxActive] = useState(false)
  const dragStartPos = useRef({ x: 0, y: 0 })
  const previewBoxRef = useRef<HTMLDivElement>(null)
  const rightRef = useRef<HTMLDivElement>(null)
  const fullText = '口播文案字幕样式预览'
  const [visibleText, setVisibleText] = useState(fullText)

  useImperativeHandle(ref, () => ({
    initFont: () => {
      handleFontChange('Douyin Sans')
    }
  }))

  const leftWidth = useMemo(() => {
    if (ratio) {
      const w = leftMaxHeight * ratio
      return Math.min(leftMaxWidth, w)
    }
    return 0
  }, [ratio])

  const previewBoxScale = useMemo(() => {
    const max = ratio > 1 ? leftWidth : leftMaxHeight
    return max / screenSize
  }, [leftWidth, ratio])

  const renderWidth = useMemo(() => {
    return leftWidth / previewBoxScale
  }, [leftWidth, previewBoxScale])

  const renderHeight = useMemo(() => {
    return renderWidth / ratio
  }, [renderWidth, ratio])

  // 在宽度变化时触发计算
  useEffect(() => {
    if (previewBox.width > 0) {
      updateVisibleText(previewBox.width / previewBoxScale)
    }
  }, [previewBox.width, previewBoxScale, fontSize, selectedFont])

  useEffect(() => {
    if (open && leftWidth > 0) {
      const leftHeight = leftWidth / ratio
      setFontSize(caption.font_size)
      setFontColor(caption.primary_color)
      setFontBorderColor(caption.outline_color)
      setFontStyleIndx(undefined)
      setSelectedFont(caption.font_name)
      setPreviewBox((prev: any) => ({
        ...prev,
        x: caption.pos_x_ratio * leftWidth,
        y: caption.pos_y_ratio * leftHeight,
        width: caption.width_ratio * leftWidth
      }))
      if (caption.font_name) {
        handleFontChange(caption.font_name)
      }
    }
  }, [caption, leftWidth, open])

  // 动态计算可见文字
  const updateVisibleText = (width: number) => {
    const selectedOption = fontOptions.find((option) => option.value === selectedFont)
    const charWidth = fontSize * (selectedOption?.fontWidth || 0.8)
    const maxChars = Math.floor(width / charWidth) - 2 // -2 避免边缘截断

    setVisibleText(fullText.slice(0, Math.max(1, maxChars)))
  }

  const loadFont = (fontName: string, fontUrl: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const fontFace = new FontFace(fontName, `url(${fontUrl})`)

      fontFace
        .load()
        .then((loadedFace) => {
          document.fonts.add(loadedFace)
          resolve()
        })
        .catch((err) => {
          console.error('字体加载失败:', err)
          reject(err)
        })
    })
  }

  const handleFontChange = async (value: string) => {
    const selectedOption = fontOptions.find((option) => option.value === value)
    if (selectedOption) {
      try {
        setFontLoading(true)
        setSelectedFont(value)
        await loadFont(selectedOption.value, selectedOption.url)
      } catch (error) {
        message.error('字体加载失败')
      } finally {
        setFontLoading(false)
      }
    }
  }

  // 处理鼠标按下 - 开始拖拽
  const handleMouseDown = (e: React.MouseEvent) => {
    if (e.currentTarget !== previewBoxRef.current) return

    dragStartPos.current = { x: e.clientX, y: e.clientY }
    setPreviewBox((prev) => ({ ...prev, isDragging: true }))
    e.preventDefault()
  }

  // 鼠标移动事件处理
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!previewBox.isDragging && !previewBox.isResizing) return

    const container = e.currentTarget as HTMLElement
    const containerRect = container.getBoundingClientRect()
    const dx = e.clientX - dragStartPos.current.x

    if (previewBox.isDragging) {
      const dy = e.clientY - dragStartPos.current.y

      setPreviewBox((prev) => ({
        ...prev,
        x: Math.max(0, Math.min(containerRect.width - prev.width, prev.x + dx)),
        y: Math.max(0, Math.min(containerRect.height - fontSize * 1.5 * previewBoxScale, prev.y + dy))
      }))
    } else if (previewBox.isResizing) {
      setPreviewBox((prev) => {
        if (previewBox.resizeDirection === 'right') {
          // 右侧调整
          const newWidth = Math.max(30, Math.min(containerRect.width - prev.x, prev.width + dx))
          return { ...prev, width: newWidth }
        } else if (previewBox.resizeDirection === 'left') {
          // 左侧调整
          const newWidth = Math.max(30, prev.width - dx)
          const newX = Math.min(prev.x + dx, prev.x + prev.width - 100)
          return { ...prev, x: newX, width: newWidth }
        }
        return prev
      })
    }

    dragStartPos.current = { x: e.clientX, y: e.clientY }
  }

  // 鼠标抬起事件
  const handleMouseUp = () => {
    setPreviewBox((prev) => ({ ...prev, isDragging: false, isResizing: false, resizeDirection: null }))
  }

  const getTextStrokeStyle = (borderColor: string, borderWidth = 2) => {
    if (!borderColor) {
      return {}
    }
    return {
      WebkitTextStroke: `${borderWidth}px ${borderColor}`,
      textStroke: `${borderWidth}px ${borderColor}`,
      paintOrder: 'stroke fill' // 确保描边在填充下方
    }
  }

  // 处理调整宽度的鼠标按下事件
  const handleResizeMouseDown = (e: React.MouseEvent, direction: 'left' | 'right') => {
    e.stopPropagation()
    dragStartPos.current = { x: e.clientX, y: e.clientY }
    setPreviewBox((prev) => ({ ...prev, isResizing: true, resizeDirection: direction }))
  }

  const onSure = () => {
    const { width, x, y } = previewBox
    const { naturalWidth, naturalHeight } = naturalSize
    const natureRatio = naturalWidth / leftWidth
    const height = fontSize * 1.5 * (Math.max(naturalWidth, naturalHeight) / screenSize)

    updateCaption({
      font_name: selectedFont,
      font_size: fontSize,
      primary_color: fontColor,
      outline_color: fontBorderColor,
      width: Math.floor(width * natureRatio),
      height: Math.floor(height),
      pos_x: Math.floor(x * natureRatio),
      pos_y: Math.floor(y * natureRatio),
      width_ratio: width / leftWidth,
      height_ratio: height / naturalHeight,
      pos_x_ratio: x / leftWidth,
      pos_y_ratio: y / (leftWidth / ratio),
      ass_ratio: screenSize / Math.max(naturalWidth, naturalHeight)
    })
    onCancel?.()
  }

  return (
    <Modal
      title={translate('create_video.select_caption')}
      open={!!open}
      width={leftWidth + 568}
      onCancel={onCancel}
      maskClosable={false}
      className="commom-modal caption-modal"
      footer={
        <Button type="primary" onClick={onSure}>
          {translate('create_video.save_setting')}
        </Button>
      }
      style={{ display: ratio ? 'block' : 'none' }}
    >
      <div className="caption-modal-wrappeer">
        <div
          className="left"
          style={{
            width: leftWidth,
            minWidth: leftWidth,
            height: leftMaxHeight
          }}
        >
          <div
            className="moveable-box"
            style={{
              position: 'absolute',
              top: '50%',
              width: renderWidth,
              minWidth: renderWidth,
              height: renderHeight,
              transform: `scale(${previewBoxScale}) translateY(-50%)`,
              transformOrigin: '0 0'
            }}
          >
            <div
              className="left-box"
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
            >
              <img
                className="img"
                src={urlSource(avatar?.video_url, 'video')}
                onLoad={(e: any) => {
                  const w = e.target?.naturalWidth
                  const h = e.target?.naturalHeight
                  setNaturalSize({ naturalWidth: w, naturalHeight: h })
                  setRatio(w / h)
                }}
                onClick={() => setIsPreviewBoxActive(false)}
              />
              <div
                ref={previewBoxRef}
                className="preview-box"
                style={{
                  left: `${previewBox.x / previewBoxScale}px`,
                  top: `${previewBox.y / previewBoxScale}px`,
                  width: `${previewBox.width / previewBoxScale}px`,
                  fontFamily: selectedFont,
                  fontSize: `${fontSize}px`,
                  color: fontColor,
                  border: isPreviewBoxActive ? '8px solid #75fa4c' : '8px solid transparent',
                  cursor: previewBox.isDragging ? 'grabbing' : 'move',
                  ...getTextStrokeStyle(fontBorderColor, 8)
                }}
                onMouseDown={(e) => {
                  e.stopPropagation()
                  handleMouseDown(e)
                  setIsPreviewBoxActive(true)
                }}
              >
                {fontLoading && (
                  <div className="loading">
                    <LoadingOutlined />
                  </div>
                )}

                <p>{visibleText}</p>
                {isPreviewBoxActive && (
                  <div
                    className="resize-handle handle-left"
                    onMouseDown={(e) => handleResizeMouseDown(e, 'left')}
                    style={{
                      position: 'absolute',
                      left: -25,
                      top: '50%',
                      transform: `translateY(-50%)`,
                      width: 50,
                      height: 50
                    }}
                  >
                    <i></i>
                  </div>
                )}

                {/* 右侧调整手柄 */}
                {isPreviewBoxActive && (
                  <div
                    className="resize-handle handle-right"
                    onMouseDown={(e) => handleResizeMouseDown(e, 'right')}
                    style={{
                      position: 'absolute',
                      right: -25,
                      top: '50%',
                      transform: `translateY(-50%)`,
                      width: 50,
                      height: 50
                    }}
                  >
                    <i></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="right" ref={rightRef}>
          <div className="form-item">
            <label className="form-item-left">{translate('create_video.font_family')}</label>
            <Select value={selectedFont} onChange={handleFontChange} className="select-fontfamily">
              {fontOptions.map((font) => (
                <Select.Option key={font.value} value={font.value}>
                  <img className={`dropdown-img ${font.className || font.value}`} src={font.previewImg} />
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="form-item">
            <label className="form-item-left">{translate('create_video.font_size')}</label>
            <Select value={fontSize} className="select-fontsize" onChange={(v) => setFontSize(v)}>
              {fontSizeList.map((v) => (
                <Select.Option key={v} value={v}>
                  {v}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="form-item">
            <label className="form-item-left">{translate('create_video.font_color')}</label>
            <ColorPicker
              disabledAlpha
              presets={presets}
              value={fontColor}
              onChange={(v: any) => {
                setFontStyleIndx(undefined)
                setFontColor(v.toHexString())
              }}
            />
          </div>

          <div className="form-item">
            <label className="form-item-left">{translate('create_video.font_border')}</label>
            <ColorPicker
              disabledAlpha
              allowClear
              presets={presets}
              value={fontBorderColor}
              onChange={(v: any) => {
                setFontStyleIndx(undefined)
                setFontBorderColor(v.toHexString())
              }}
            />
          </div>

          <div className="form-item">
            <label className="form-item-left">{translate('create_video.font_style')}</label>
            <div className="form-item-right">
              <div className="colors">
                <div
                  className="color-box blank"
                  onClick={() => {
                    setFontBorderColor('')
                    setFontColor('#FFFFFF')
                    setFontStyleIndx(undefined)
                  }}
                >
                  <StopOutlined />
                </div>
                {styleList.map((style, index) => (
                  <div
                    className={`color-box ${index === fontStyleIndx ? 'actived' : ''}`}
                    key={index}
                    onClick={() => {
                      setFontBorderColor(style.borderColor)
                      setFontColor(style.fontColor)
                      setFontStyleIndx(index)
                    }}
                  >
                    <div
                      className="top"
                      style={{
                        background: style.fontColor,
                        border: `2px solid ${style.borderColor}`,
                        boxShadow: `0 0 4px 0 rgb(0 0 0 / 50%)`
                      }}
                    ></div>
                    <div
                      className="bottom"
                      style={{
                        background: style.fontColor,
                        border: `2px solid ${style.borderColor}`,
                        borderTop: 'none',
                        boxShadow: `0 3px 6px 0 rgb(0 0 0 / 20%)`
                      }}
                    ></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
})

CaptionModal.displayName = 'CaptionModal'

export default CaptionModal
